import PropTypes from 'prop-types';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

import useScrapeGuard from 'hooks/useScrapeGuard';

/* Wraps the part of a catalogue screen that is worth harvesting - the table,
 * not the filters - and swaps it for a notice while an extractor extension is
 * on the page.
 *
 * A notice rather than a thrown error or a blank area: the customer who trips
 * this may well be a dealer who installed something months ago and has no idea
 * it is running, and a page that simply breaks tells them the site is broken.
 * The rows are what has to stop being there; saying why costs nothing and keeps
 * the support call short.
 */
const ScrapeGuard = ({ children }) => {
  const { t } = useTranslation('common');
  const detected = useScrapeGuard();

  if (!detected) return <>{children}</>;

  return (
    <Alert
      type="warning"
      showIcon
      className="custom-alert"
      message={t('scrape-guard-title')}
      description={t('scrape-guard-body')}
    />
  );
};

ScrapeGuard.propTypes = {
  children: PropTypes.node,
};

export default ScrapeGuard;
